// extracted by css-extract-rspack-plugin
export default {"heartWrapper":"_fbcd85c9"};